module.exports = __webpack_public_path__ + "static/002-7c5f956fdf35ac6b18e0fbf7d7007ab8.png";